export default __webpack_public_path__ + "media/Alcohol-Japanese-Sake-Shochu.5393a7d0.png";